/* WICK 11/10/2026: cintas en movimiento en el carrito (como Scuffers).
   1) Worldwide Shipping / Easy Returns + sellos de pago seguro, encima del descuento y el subtotal.
   2) Logos de metodos de pago debajo del boton de pagar: coge los logos que pinta wick-upt.js (.wk-pay) y quita repetidos.
   Se vuelven a poner solas cuando el carrito se actualiza.
   WICK 13/10/2026: la cinta no se para nunca:
   - al actualizar el carrito sigue por donde iba (no vuelve al principio)
   - un vigilante comprueba cada segundo que se mueve; si se queda quieta (al abrir/cerrar el carrito,
     al volver a la pestana o con el ahorro de bateria del movil) la vuelve a arrancar
   - el modo "reducir movimiento" del movil ya no la frena
   - nunca queda en blanco: al repintarse el carrito se pone en el mismo instante, y los logos usan una copia guardada mientras llegan
   WICK 21/10/2026: el codigo de descuento salia dos veces en el carrito. Se oculta el recuadro gris que pinta la app
   (codigo + importe + X, debajo de los puntos) y se deja solo la linea de Shopify encima del total (codigo e importe real).
   WICK 21/10/2026 (3): los logos de tarjetas ya NO se mueven: fila fija (solo se mueve la cinta de pago seguro).
   Y no repiten Shop Pay, Apple Pay, PayPal ni Google Pay, que ya salen como botones de pago rapido justo encima.
   La caja de puntos (app Joy) reservaba mas alto del que ocupa: se ajusta su altura al borde real del recuadro (sin hueco y sin pisar nada).
   WICK 21/10/2026 (4): la parte de abajo queda fija: se miden el pie (--wk-foot-h) y la caja de puntos (--wk-joy-h)
   para apilar encima la caja de puntos y "You may also like".
   WICK 21/10/2026 (6): sin margenes laterales caben todos los logos en una linea. Orden:
   Visa, Mastercard, American Express, Discover, Amazon Pay, Bizum, iDEAL | Wero, Bancontact, Diners Club, MB WAY, Satispay.
   Los logos copiados llevan ids propios (sufijo -wkf): con los ids repetidos, en Chrome Discover salia sin la O naranja
   y Bancontact sin colores (sus degradados apuntaban a la copia oculta). */
(function () {
  if (window.__wkMq) return;
  window.__wkMq = true;
  var SPEED = 40; /* pixeles por segundo */
  var T0 = Date.now();
  var items = ['Worldwide Shipping', 'Easy Returns'];
  var lock = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
  var shield = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M9 12l2 2 4-4"/></svg>';
  var seals = [
    '<em class="wk-mq__seal">' + lock + 'Secure checkout <small>SSL encrypted</small></em>',
    '<em class="wk-mq__seal">' + shield + 'Protected payment <small>PCI DSS certified</small></em>',
    '<em class="wk-mq__seal">' + lock + '100% secure payment · SSL</em>'
  ];
  /* Metodos que ya salen como botones de pago rapido: no se repiten en los logos */
  var EXPRESS = /shop(ify)?[ _-]?pay|apple|paypal|google|g[ _-]?pay/i;
  /* Logos que se muestran (en este orden); el resto no sale */
  var KEEP = [/visa/i, /master/i, /american|amex/i, /discover/i, /amazon/i, /bizum/i, /ideal|wero/i, /bancontact/i, /diners/i, /mb[ _-]?way/i, /satispay/i];
  function seq() {
    var h = '';
    for (var i = 0; i < items.length; i++) h += '<span>' + items[i] + '</span><i>•</i>';
    for (var j = 0; j < seals.length; j++) h += seals[j] + '<i>•</i>';
    return '<div class="wk-mq__seq">' + h + '</div>';
  }
  function putText(d) {
    var f = d.querySelector('.drawer__footer');
    if (!f || f.querySelector('.wk-mq--text')) return;
    var m = document.createElement('div');
    m.className = 'wk-mq wk-mq--text';
    m.setAttribute('role', 'note');
    m.setAttribute('aria-label', items.join(' · ') + ' · Secure checkout, SSL encrypted · Protected payment, PCI DSS certified');
    m.innerHTML = '<div class="wk-mq__track" aria-hidden="true">' + seq() + seq() + '</div>';
    f.insertAdjacentElement('afterbegin', m);
  }
  /* ids propios para los logos copiados (los degradados de Discover y Bancontact dependen de ellos) */
  function uniqIds(h) {
    var ids = [], re = /\sid="([^"]+)"/g, mm;
    while ((mm = re.exec(h))) ids.push(mm[1]);
    for (var i = 0; i < ids.length; i++) {
      var a = ids[i], b = a + '-wkf';
      h = h.split('id="' + a + '"').join('id="' + b + '"').split('#' + a + ')').join('#' + b + ')').split('#' + a + '"').join('#' + b + '"').split('labelledby="' + a + '"').join('labelledby="' + b + '"');
    }
    return h;
  }
  var payCache = '';
  function putPay(d) {
    if (d.querySelector('.wk-mq--pay')) return;
    var pay = d.querySelector('.wk-pay');
    var lis = pay ? pay.querySelectorAll('li') : [];
    if (!lis.length) {
      /* Los logos aun no estan pintados (carrito recien actualizado): se pone la copia guardada para que nunca quede en blanco */
      var ctas = d.querySelector('.cart__ctas');
      if (!payCache || !ctas) return;
      var c = document.createElement('div');
      c.className = 'wk-mq wk-mq--pay wk-mq--fixed';
      c.innerHTML = payCache;
      ctas.insertAdjacentElement('afterend', c);
      return;
    }
    var slots = [];
    for (var i = 0; i < lis.length; i++) {
      var svg = lis[i].querySelector('svg');
      var key = svg ? (svg.getAttribute('aria-labelledby') || lis[i].textContent) : lis[i].innerHTML;
      var ttl = svg && svg.querySelector('title') ? svg.querySelector('title').textContent : '';
      var lab = (key || '') + ' ' + ttl + ' ' + lis[i].textContent;
      if (EXPRESS.test(lab)) continue;
      for (var k = 0; k < KEEP.length; k++) {
        if (!slots[k] && KEEP[k].test(lab)) { slots[k] = '<span class="wk-mq__logo">' + lis[i].innerHTML + '</span>'; break; }
      }
    }
    var h = uniqIds(slots.filter(Boolean).join(''));
    if (!h) return;
    var m = document.createElement('div');
    m.className = 'wk-mq wk-mq--pay wk-mq--fixed';
    m.innerHTML = '<div class="wk-mq__fixed">' + h + '</div>';
    payCache = m.innerHTML;
    pay.insertAdjacentElement('afterend', m);
  }
  /* Parte fija: alto real del pie y de la caja de puntos para apilar encima la caja de puntos y "You may also like" */
  function footVar(d) {
    var f = d.querySelector('.drawer__footer');
    if (!f) return;
    var h = Math.ceil(f.getBoundingClientRect().height);
    if (!h) return;
    var v = h + 'px';
    if (d.style.getPropertyValue('--wk-foot-h') !== v) d.style.setProperty('--wk-foot-h', v);
    var j = d.querySelector('.joy-redeem-inline');
    var jh = j ? Math.ceil(j.getBoundingClientRect().height) : 0;
    var jv = jh + 'px';
    if (d.style.getPropertyValue('--wk-joy-h') !== jv) d.style.setProperty('--wk-joy-h', jv);
  }
  /* Caja de puntos: altura = hasta el borde de abajo del recuadro de la app (el mas exterior con borde) + 5px de aire */
  function fitJoy(d) {
    var j = d.querySelector('.joy-redeem-inline');
    if (!j) return;
    var b = j.querySelector('.Avada-Joy-Redeem-Inline__balance-container');
    if (!b || !b.parentElement) { j.style.removeProperty('height'); return; }
    var box = b.parentElement, el = box;
    while (el && el !== j) {
      var cs = getComputedStyle(el);
      if (parseFloat(cs.borderBottomWidth) > 0 || parseFloat(cs.borderTopWidth) > 0) box = el;
      el = el.parentElement;
    }
    var jr = j.getBoundingClientRect(), br = box.getBoundingClientRect();
    if (!br.height) return;
    var h = Math.ceil(br.bottom - jr.top + 5) + 'px';
    if (j.style.height !== h) j.style.setProperty('height', h, 'important');
  }
  /* WICK 21/10/2026: oculta el recuadro del cupon que pinta la app (el codigo salia repetido).
     Busca en el carrito el texto de cada codigo que Shopify ya muestra en su linea de descuento (.discounts)
     y oculta el recuadro de la app que lo contiene (el primer bloque que tiene codigo + importe), nunca la linea de Shopify. */
  var AMT = /[-−–]\s*(?:[€$£¥₩]\s*)?\d[\d.,]*/;
  function hideAppCoupon(d) {
    var codes = [];
    d.querySelectorAll('.discounts__discount--end').forEach(function (li) {
      var t = li.textContent.replace(/\s+/g, ' ').trim();
      var m = t.match(/^(.*?)\s*\(/);
      if (m && m[1]) codes.push(m[1].trim().toLowerCase());
    });
    if (!codes.length) return;
    var w = document.createTreeWalker(d, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var v = (n.nodeValue || '').toLowerCase();
      if (!v.trim()) continue;
      var hit = false;
      for (var i = 0; i < codes.length; i++) if (v.indexOf(codes[i]) !== -1) { hit = true; break; }
      if (!hit) continue;
      var el = n.parentElement;
      if (!el || el.closest('.discounts, .cart-item, .wk-mq, .totals, .tax-note')) continue;
      var box = el;
      for (var k = 0; k < 4 && box; k++) {
        if (AMT.test(box.textContent)) break;
        box = box.parentElement;
      }
      if (!box || box === d || box.querySelector('.discounts, .cart-item, .cart__ctas, .totals')) continue;
      if (box.style.display !== 'none') box.style.setProperty('display', 'none', 'important');
    }
  }
  /* Arranca (o vuelve a arrancar) la cinta a la velocidad fija y en el punto que le toca segun el reloj comun,
     asi siempre sigue por donde iba aunque el carrito se haya vuelto a pintar */
  function run(t, force) {
    var w = t.scrollWidth / 2;
    if (!w) return false;
    var dur = Math.max(5, Math.round(w / SPEED * 10) / 10);
    var phase = ((Date.now() - T0) / 1000) % dur;
    var durS = dur + 's';
    if (!force && t.dataset.wkDur === durS && t.style.animationName !== 'none') return true;
    t.dataset.wkDur = durS;
    t.style.setProperty('animation', 'none', 'important');
    void t.offsetWidth;
    t.style.setProperty('animation', 'wk-mq ' + durS + ' linear -' + phase.toFixed(2) + 's infinite normal none running', 'important');
    t.dataset.wkX = '';
    return true;
  }
  function syncSpeed(d) {
    d.querySelectorAll('.wk-mq__track').forEach(function (t) { run(t, false); });
  }
  /* Vigilante: si la cinta visible no se ha movido desde la ultima comprobacion, se vuelve a arrancar */
  function watch() {
    var d = document.querySelector('cart-drawer');
    if (!d || document.hidden) return;
    hideAppCoupon(d);
    fitJoy(d);
    footVar(d);
    d.querySelectorAll('.wk-mq__track').forEach(function (t) {
      var r = t.getBoundingClientRect();
      var box = t.parentElement.getBoundingClientRect();
      if (!r.width || box.bottom < 0 || box.top > window.innerHeight || box.left >= window.innerWidth || box.right <= 0) return;
      var x;
      try { x = new DOMMatrixReadOnly(getComputedStyle(t).transform).m41; } catch (e) { x = r.left; }
      var last = t.dataset.wkX;
      t.dataset.wkX = String(Math.round(x * 10) / 10);
      if (last !== '' && last !== undefined && last === t.dataset.wkX) run(t, true);
    });
  }
  function put() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    putText(d);
    putPay(d);
    syncSpeed(d);
    hideAppCoupon(d);
    fitJoy(d);
    footVar(d);
  }
  function restartAll() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    put();
    d.querySelectorAll('.wk-mq__track').forEach(function (t) { run(t, true); });
  }
  function start() {
    put();
    var d = document.querySelector('cart-drawer');
    /* Se vuelven a poner en el mismo instante en que el carrito se repinta (antes de que se vea la pantalla), asi nunca hay un hueco en blanco */
    if (d) new MutationObserver(function () { put(); clearTimeout(window.__wkMqT); window.__wkMqT = setTimeout(put, 60); }).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', function () { clearTimeout(window.__wkMqR); window.__wkMqR = setTimeout(restartAll, 150); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) setTimeout(restartAll, 50); });
    window.addEventListener('pageshow', function () { setTimeout(restartAll, 50); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('#cart-icon-bubble, .cart-drawer__overlay, .drawer__close')) setTimeout(restartAll, 400); }, true);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(restartAll);
    setInterval(watch, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
